"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormatMarginRecord = exports.useFormatFundingRecord = exports.useFetchTransferRecord = exports.useFetchOrderIncome = void 0;
const common_business_1 = require("@pionex-web-kit/common-business");
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
function useFetchOrderIncome({ id, orderType, income_type, trend, shouldFetchData = true, }) {
    var _a;
    const [data, setData] = (0, react_1.useState)({
        results: [],
        hasMore: false,
        refreshLoading: false,
    });
    const [{ loading: loadMoreLoading, error: loadingError }, fetch] = (0, common_business_1.useAsyncFn)((nexPageToken) => __awaiter(this, void 0, void 0, function* () {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${id}/income/`;
        if (orderType === TradeAPILib_1.ExchangeOrderType.futures_smart_trade) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${id}/funding_fee/`;
        }
        const params = {};
        if (income_type !== undefined) {
            params.income_type = income_type;
        }
        if (nexPageToken) {
            params.page_token = nexPageToken;
        }
        if (trend) {
            params.trend = trend;
        }
        const result = yield (0, rxjs_1.firstValueFrom)(trade_utils_lib_1.Network.get({ url: url, data: params, authType: trade_utils_lib_1.AuthType.AccessAndSpot }));
        setData((current) => {
            return {
                next_page_token: result.next_page_token,
                hasMore: !!result.next_page_token,
                refreshLoading: false,
                results: nexPageToken ? [...(current.results || []), ...result.results] : result.results,
            };
        });
        return;
    }));
    const loadMore = (0, common_business_1.usePersistFn)(() => {
        if (!shouldFetchData) {
            return;
        }
        if (!loadMoreLoading && data.hasMore) {
            fetch(data.next_page_token);
        }
    });
    const refresh = (0, common_business_1.usePersistFn)(() => {
        if (!shouldFetchData) {
            return;
        }
        setData((pre) => {
            return Object.assign(Object.assign({}, pre), { refreshLoading: true });
        });
        fetch();
    });
    (0, react_1.useEffect)(() => {
        refresh();
    }, [id, orderType, refresh, trend]);
    (0, react_1.useEffect)(() => {
        if (loadingError && data.refreshLoading) {
            setData((pre) => {
                return Object.assign(Object.assign({}, pre), { refreshLoading: false });
            });
        }
    }, [loadingError]);
    return {
        loadMore,
        loadMoreLoading,
        loadingError,
        refreshLoading: data.refreshLoading,
        refresh,
        data: shouldFetchData ? data.results : [],
        hasMore: (_a = data.hasMore) !== null && _a !== void 0 ? _a : false,
    };
}
exports.useFetchOrderIncome = useFetchOrderIncome;
function useFetchTransferRecord({ id, orderType, type, }) {
    var _a;
    const [data, setData] = (0, react_1.useState)({
        results: [],
        hasMore: false,
        refreshLoading: false,
    });
    const [{ loading: loadMoreLoading, error: loadingError }, fetch] = (0, common_business_1.useAsyncFn)((nexPageToken) => __awaiter(this, void 0, void 0, function* () {
        let url = "";
        if ([TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid, TradeAPILib_1.ExchangeOrderType.gridV4Futures, TradeAPILib_1.ExchangeOrderType.futures_martingale].includes(orderType)) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${id}/transfer/`;
        }
        else if (orderType === TradeAPILib_1.ExchangeOrderType.futures_smart_trade) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${id}/transfer_history/`;
        }
        else {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${id}/transfer/`;
        }
        const params = {};
        if (type !== undefined) {
            params.type = type;
        }
        if (nexPageToken) {
            params.page_token = nexPageToken;
        }
        const result = yield (0, rxjs_1.firstValueFrom)(trade_utils_lib_1.Network.get({
            url,
            data: params,
            authType: orderType === TradeAPILib_1.ExchangeOrderType.futures_smart_trade ? trade_utils_lib_1.AuthType.FullToken : trade_utils_lib_1.AuthType.Access,
        }));
        setData((current) => {
            return {
                next_page_token: result.next_page_token,
                hasMore: !!result.next_page_token,
                refreshLoading: false,
                results: nexPageToken ? [...(current.results || []), ...result.results] : result.results,
            };
        });
        return;
    }));
    const loadMore = (0, common_business_1.usePersistFn)(() => {
        if (!loadMoreLoading && data.hasMore) {
            fetch(data.next_page_token);
        }
    });
    const refresh = (0, common_business_1.usePersistFn)(() => {
        setData((pre) => {
            return Object.assign(Object.assign({}, pre), { refreshLoading: true });
        });
        fetch();
    });
    (0, react_1.useEffect)(() => {
        refresh();
    }, [id, orderType, refresh]);
    (0, react_1.useEffect)(() => {
        if (loadingError && data.refreshLoading) {
            setData((pre) => {
                return Object.assign(Object.assign({}, pre), { refreshLoading: false });
            });
        }
    }, [loadingError]);
    return {
        loadMore,
        loadMoreLoading,
        refreshLoading: data.refreshLoading,
        refresh,
        data: data.results,
        hasMore: (_a = data.hasMore) !== null && _a !== void 0 ? _a : false,
    };
}
exports.useFetchTransferRecord = useFetchTransferRecord;
function useFormatFundingRecord(item, $st, convertMillisecond = true) {
    const bool = !item.amount.includes("-");
    const value = bool
        ? `+${(0, common_business_1.formatNum)(item.amount, { decimal: 8, isPad: false })} ${item.coin}`
        : `${(0, common_business_1.formatNum)(item.amount, { decimal: 8, isPad: false })} ${item.coin}`;
    return {
        direction: bool,
        title: bool ? $st("grid_futures_funding_revenue") : $st("grid_futures_funding_cost"),
        value,
        date: convertMillisecond ? item.timestamp * 1000 : item.timestamp,
    };
}
exports.useFormatFundingRecord = useFormatFundingRecord;
function useFormatMarginRecord(item, $st) {
    var _a;
    const bool = ((_a = item.direction) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "in";
    const value = bool
        ? `+${(0, common_business_1.formatNum)(item.amount, { decimal: 8, isPad: false })} ${item.coin}`
        : `-${(0, common_business_1.formatNum)(item.amount, { decimal: 8, isPad: false })} ${item.coin}`;
    let subTitle = "";
    const title = (() => {
        switch (item.type) {
            case "investment":
                return bool ? $st("mtg_add_and_withdraw_history_add_investment") : $st("mtg_add_and_withdraw_history_withdraw_investment");
            case "margin":
                let text = "";
                if (item.status === "error") {
                    text = bool ? $st("transfer_type_margin_in_error") : $st("transfer_type_margin_out_error");
                }
                else {
                    text = bool ? $st("transfer_type_margin_in") : $st("transfer_type_margin_out");
                    if (item.status === "prepare") {
                        text += `(${$st("dw_record_status_processing")})`;
                    }
                }
                if (item.margin_source === "adjust_params") {
                    subTitle = $st("grid_position_adjust_position");
                }
                return text;
            default:
                return "";
        }
    })();
    return {
        direction: bool,
        title,
        subTitle,
        value,
        date: item.create_time,
    };
}
exports.useFormatMarginRecord = useFormatMarginRecord;
